import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { StyledUtils } from '@ocean/utils'

export const Tag = styled.div`
  ${StyledUtils.clearButton}

  border: 0;
  display: inline-flex;
  white-space: nowrap;
  transition: background-color 0.3s ease;
  text-transform: uppercase;
  cursor: auto;

  ${({ theme }) => `
    background-color: ${theme.color.gold};
    color: ${theme.color.black};
    padding: ${theme.space.mobile.tiny} ${theme.space.mobile.small};
    font-weight: ${theme.fontWeight.semibold};
    font-family: ${theme.fontFamily.secondary};
    font-size: ${theme.fontSize.mobile.small};
    border-radius: calc(${theme.space.mobile.base} + ${theme.space.mobile.nano});

    &:not(:last-child) {
      margin-right: calc(${theme.space.mobile.small});
    }
  `}

  ${({ theme }) => media.sm`
    border-radius: ${theme.space.desktop.base};
    padding: ${theme.space.desktop.tiny} ${theme.space.desktop.small};
    font-size: ${theme.fontSize.desktop.small};

    :not(:last-child) {
      margin-right: ${theme.space.desktop.small};
    }
  `}
`
